/**
 * Created by mykurisu on 2017/8/21.
 */
import React from 'react'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import axios from 'axios'
import {Toast, Dialog} from 'react-weui'
import {Page, WKError} from '../../components'
import { WKVisible } from '../../components/wk'
import '../../css/page/LecturerInvitePage.css'
import errorImg from '../../images/no-source.png'
import logoShareImg from '../../images/icon-logo-share.png'
import {isLZWKAPP, TimeStream} from '../../utils'
import config from '../../config'
import { HTTPClient } from '@weike/toolkit'

const gwHttp = new HTTPClient({baseURL: config.BASE_URL_ELSE}, '0000')
class LecturerInviteCard extends React.Component {

    constructor() {
        super();
        this.state = {
            iconRotate: false,
            loading: false,
            dialogShow: false,
            dialogButton: [
                {
                    label: '好的',
                    onClick: this.handleEnterClassroom.bind(this)
                }
            ]
        };
        document.title = '嘉宾邀请函'
        this.isApp = isLZWKAPP()
        this.handleCardTouch = this.handleCardTouch.bind(this);
    }

    handleCardTouch() {
        if(this.isApp){
            const title = "课程嘉宾邀请"
            const description = "课程嘉宾邀请卡"
            const link = window.location.href
            const icon = "https://static-cos.lycheer.net/xupload/20191206_WechatIMG127.jpeg"
            if(window.systemType === 'android'){
                WKApp.shareUrl(title, description, link, icon);
            } else {
                const dic = {
                    "function": "shareUrl",
                    "json": {
                        "share_description": title,
                        "share_icon": icon,
                        "share_title": description,
                        "share_url": link
                    }
                }
                window.webkit.messageHandlers.WKApp.postMessage(dic)
            }
        }
    }

    /**
     * 将以前weike的邀请卡功能迁移至wk-business-sharecard，统一管理
     * 以前接口：/api/lecture/${target_id}/lecturer/qrcode_invite
     * 时间: 2023-01-10
     */
    getCardInfo () {
        let target_id = this.props.routeParams.target_id;
        let type = this.props.routeParams.type;
        gwHttp.post('/v1/integration/wk_business_sharecard/cards.card.get', {
            card_type: "lecturer_invite_sharecard",
            api_params: {
                lecture_id: target_id,
                object_id: target_id,
                object_type: type
            }
        }).then(res => {
            if (res.code === '0000') {
                this.props.dispatch({
                    type: 'LECTURER_INVITE_CARD_INIT',
                    payload: { ...this.props.inviteCard, ...res.data }
                })
                this.getRole()
            } else {
                this.page.showAlert(res.msg)
            }
        }).catch((error) => {
            this.abnormalHandler(error)
        });
    }

    // 由于接口迁移is_lecturer, is_manager字段接口不太好提供，所以调用接口获取
    getRole () {
        let target_id = this.props.routeParams.target_id;
        axios.get(`/api/lecture/${target_id}/info`).then(res => {
            if (res.data.code === 0) {
                const { is_lecturer, is_manager } = res.data.data.role
                this.props.dispatch({
                    type: 'LECTURER_INVITE_CARD_INIT',
                    payload: { ...this.props.inviteCard, is_lecturer, is_manager }
                })
                if (!is_manager && is_lecturer){
                    this.setState({
                        dialogShow: true
                    })
                }
            }
        }).catch((error) => {
            this.abnormalHandler(error)
        });
    }

    componentDidMount() {
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: {
                title: '课程嘉宾邀请',
                desc: '课程嘉宾邀请卡',
                imgUrl: logoShareImg,
                type: 'link',
                link: window.location.href
            }
        });
        this.getCardInfo()
    }

    abnormalHandler(error){
        if (error.response && error.response.status === 404) {
          this.props.dispatch({
              type: 'ERROR_SHOW',
              payload: {
                  tips: '网络连接出问题了。',
                  img: errorImg,
                  href: '/?st=lecturer_invite_404',
                  btn: '去首页看看'
              }
          });
        } else if (error.response && error.response.status === 403){
            this.props.dispatch({
                type: 'ERROR_SHOW',
                payload: {
                    tips: '你没有查看此内容的权限',
                    img: errorImg,
                    href: '/?st=lecturer_invite_403',
                    btn: '去首页看看'
                }
            });
        }
    }

    handleEnterClassroom() {
        this.setState({
            dialogShow: false
        });
        let target_id = this.props.routeParams.target_id;
        browserHistory.replace(`/lecture2/${target_id}`)
        window.location.reload()
    }

    componentWillUnmount() {
        this.toastTimer && clearTimeout(this.toastTimer)
    }

    render() {
        const {inviteCard, error} = this.props;

        if (error.showError) {
            return (
                <div style={{background: '#fff', width: '100%', height: '100vh'}}>
                    <WKError />
                </div>
            )
        }


        return (
            <Page parent={this}>
                <Dialog type="ios" title={'温馨提示'} buttons={this.state.dialogButton} show={this.state.dialogShow}>
                    你已是本课程的嘉宾，<br/>
                    现已可以以讲师身份进入课堂
                </Dialog>
                <Toast icon="loading" show={this.state.loading}/>
                <div className="lecturer-invite-card">
                    {inviteCard &&
                    <div>
                        <div className="card-area" onClick={this.handleCardTouch} >
                            <img src={inviteCard.card_url} alt=""/>
                        </div>
                        {inviteCard.is_manager &&
                        <div className="info-area">
                            <WKVisible create={isLZWKAPP()}>
                                <div className="app-share-btn" onClick={this.handleCardTouch}>点击此处分享给嘉宾</div>
                            </WKVisible>
                            <p>{isLZWKAPP() ? '1.分享给好友，好友点击链接后即可成为嘉宾' : '1.长按上图，分享给好友即可邀请用户成为嘉宾'}</p>
                            <p>2.邀请函会于{TimeStream(inviteCard.expire_ts, 'YMD')}过期</p>
                        </div>
                        }
                    </div>
                    }
                </div>
            </Page>
        )
    }
}


export default connect(state => ({
    inviteCard: state.lecturerInvite.inviteCard,
    error: state.error,
}))(LecturerInviteCard)



// WEBPACK FOOTER //
// ./src/pages/lecutrerInvite/LecturerInviteCard.js